import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/seo/trades")({
  component: () => <Outlet />,
});
